"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _utils = require("../utils");

var _ = require("..");

var _Visibility = _interopRequireDefault(require("../utils/Visibility"));

var usePrefetch = function usePrefetch(path) {
  var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (!ref.current) {
      return;
    }

    (0, _Visibility["default"])(ref.current, function () {
      return (0, _.prefetch)((0, _utils.getRoutePath)(path));
    });
  }, [ref.current, path]);
  return ref;
};

var _default = usePrefetch;
exports["default"] = _default; //# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9icm93c2VyL2hvb2tzL3VzZVByZWZldGNoLmpzIl0sIm5hbWVzIjpbInVzZVByZWZldGNoIiwicGF0aCIsInJlZiIsImN1cnJlbnQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBOztBQUNBOztBQUNBOztBQUNBOztBQUVBLElBQU1BLFdBQVcsR0FBRyxTQUFkQSxXQUFjLENBQUNDLElBQUQsRUFBMEI7QUFBQSxNQUFuQkMsR0FBbUIsdUVBQWIsb0JBQWE7QUFDNUMsd0JBQVUsWUFBTTtBQUNkLFFBQUksQ0FBQ0EsR0FBRyxDQUFDQyxPQUFULEVBQWtCO0FBQ2hCO0FBQ0Q7O0FBQ0QsZ0NBQVVELEdBQUcsQ0FBQ0MsT0FBZCxFQUF1QjtBQUFBLGFBQU0sZ0JBQVMseUJBQWFGLElBQWIsQ0FBVCxDQUFOO0FBQUEsS0FBdkI7QUFDRCxHQUxELEVBS0csQ0FBQ0MsR0FBRyxDQUFDQyxPQUFMLEVBQWNGLElBQWQsQ0FMSDtBQU9BLFNBQU9DLEdBQVA7QUFDRCxDQVREOztlQVdlRixXIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgdXNlRWZmZWN0LCB1c2VSZWYgfSBmcm9tICdyZWFjdCdcbmltcG9ydCB7IGdldFJvdXRlUGF0aCB9IGZyb20gJy4uL3V0aWxzJ1xuaW1wb3J0IHsgcHJlZmV0Y2ggfSBmcm9tICcuLidcbmltcG9ydCBvblZpc2libGUgZnJvbSAnLi4vdXRpbHMvVmlzaWJpbGl0eSdcblxuY29uc3QgdXNlUHJlZmV0Y2ggPSAocGF0aCwgcmVmID0gdXNlUmVmKCkpID0+IHtcbiAgdXNlRWZmZWN0KCgpID0+IHtcbiAgICBpZiAoIXJlZi5jdXJyZW50KSB7XG4gICAgICByZXR1cm5cbiAgICB9XG4gICAgb25WaXNpYmxlKHJlZi5jdXJyZW50LCAoKSA9PiBwcmVmZXRjaChnZXRSb3V0ZVBhdGgocGF0aCkpKVxuICB9LCBbcmVmLmN1cnJlbnQsIHBhdGhdKVxuXG4gIHJldHVybiByZWZcbn1cblxuZXhwb3J0IGRlZmF1bHQgdXNlUHJlZmV0Y2hcbiJdfQ==

void function register() {
  /* react-hot-loader/webpack */
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }
  /* eslint-disable camelcase, no-undef */


  var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : exports;
  /* eslint-enable camelcase, no-undef */

  if (!webpackExports) {
    return;
  }

  if (typeof webpackExports === 'function') {
    reactHotLoader.register(webpackExports, 'module.exports', "/opt/build/repo/node_modules/react-static/lib/browser/hooks/usePrefetch.js");
    return;
  }
  /* eslint-disable no-restricted-syntax */


  for (var key in webpackExports) {
    /* eslint-enable no-restricted-syntax */
    if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) {
      continue;
    }

    var namedExport = void 0;

    try {
      namedExport = webpackExports[key];
    } catch (err) {
      continue;
    }

    reactHotLoader.register(namedExport, key, "/opt/build/repo/node_modules/react-static/lib/browser/hooks/usePrefetch.js");
  }
}();